import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

// DJB-118: light/dark theme choice, persisted across sessions (localStorage,
// unlike the per-session nav collapse) and applied as a data-theme attribute
// on <html> that the CSS tokens in theme.css key off. index.html applies the
// stored value before first paint so a dark reload never flashes light.
export const THEME_STORAGE_KEY = 'djb-theme';

const readStoredTheme = () => {
  try {
    return window.localStorage.getItem(THEME_STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch (e) {
    return 'light';
  }
};

export const ThemeContext = createContext(undefined);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(readStoredTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => {
      const next = prev === 'dark' ? 'light' : 'dark';
      try {
        window.localStorage.setItem(THEME_STORAGE_KEY, next);
      } catch (e) {
        // Storage unavailable — the theme still switches for this session
      }
      return next;
    });
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Guarded like the AuthContext usage in SideNav, so components render
// standalone (tests) without a provider
export const useTheme = () => useContext(ThemeContext) || {};

export default ThemeProvider;
